export default function Reducer(state, action) {
  switch (action.type) {
    case 'SET_FILTERS':
      return {
        ...state,
        filters: action.filters,
      };

    case 'LOAD_STATISTICS':
      return {
        ...state,
        statistics: action.statistics,
      };

    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}
